var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkCardChargingHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5384 41.9794H48.6691V18.9486H22.5384V41.9794ZM22.5384 77.8716H48.6691V46.5177H22.5384V77.8716ZM18 82.41V14.4102H53.2075V46.7485H63.8997V78.21H76.4228V35.4486H71.9613V24.6794H73.769V20.1795H76.5766V24.6794H80.2689V20.1795H83.0766V24.6794H84.8843V35.4486H80.4612V82.41H59.8613V50.7869H53.2075V82.41H18ZM34.0845 73.6254L41.7691 60.6255H37.1614V50.664L29.5384 63.6639H34.0845V73.6254Z",
    fill: "#F0512C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCardChargingHover);
export default __webpack_public_path__ + "static/media/linkCard_charging_hover.7e03d6d13e4ac76976158e5aca72f7d0.svg";
export { ForwardRef as ReactComponent };